// Floor API functions
import { getData, deleteData, postData, putData } from '../apiClient';

const BASE_URL = '/pool-type';
const model = 'Pool Type';

// Get floors with pagination
export const getPoolTypeWithPagination = async ({ page = 1, limit = 10, search = '' }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`${BASE_URL}/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error(`Get ${model} API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single floor by ID
export const getPoolTypeById = async (id) => {
    try {
        const result = await getData(`${BASE_URL}/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error(`Get ${model} by ID API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Create new pool type
export const createPoolType = async ({ data }) => {
    try {
        const result = await postData(`${BASE_URL}/create-pool-type`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`Create ${model} API error:`, error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
            },
        };
    }
};

// Update pool type
export const updatePoolType = async ({ id, data }) => {
    try {
        const result = await putData(`${BASE_URL}/update-pool-type/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`Update ${model} API error:`, error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
            },
        };
    }
};

// Delete pool type
export const deletePoolType = async ({ id }) => {
    try {
        const result = await deleteData(`${BASE_URL}/delete-pool-type/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error(`Delete ${model} API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};